export enum TaskCommands {
  Tasks = 'Tasks',
  Bots = 'Bots',
}
